package com.tixforgigs.common.ui.components.mandarin

import io.kvision.core.Component
import io.kvision.core.Container
import io.kvision.event.clickFlow
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.button.textButton
import io.kvision.material.dialog.DialogType
import io.kvision.material.dialog.MdDialog
import io.kvision.material.dialog.dialog
import io.kvision.material.slot.headline
import io.kvision.panel.HPanel
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach

@OptIn(ExperimentalMaterialApi::class)
fun Container.mandarinDialog(
  title: String,
  content: Component? = null,
  cancel: Pair<String, suspend () -> Unit>,
  confirm: Pair<String, suspend () -> Unit>? = null,
  additionalActions: (HPanel.() -> Unit)? = null
): MdDialog = dialog(
  type = DialogType.Alert
) {
  headline(title)
  content(content)
  actions(
    HPanel {
      additionalActions?.invoke(this)

      textButton(
        text = cancel.first
      ).clickFlow.onEach {
        cancel.second()
        close()
      }.launchIn(MainScope())

      confirm?.let { confirm ->
        textButton(
          text = confirm.first
        ).clickFlow.onEach {
          confirm.second()
          close()
        }.launchIn(MainScope())
      }
    }
  )
}